<template>
  <img v-if="src" :src="src" v-bind="$attrs" />
  <slot v-else name="fallback" />
</template>

<script setup>
import { computed, defineProps } from 'vue'
import { useAuthFile } from '../../composables/useAuthFile'

const props = defineProps({
  path: { type: String, default: '' },
})

const { src } = useAuthFile(computed(() => props.path))
</script>
